module.exports = __webpack_public_path__ + "img/cb_K2.39b0b696.svg";